import type { Component } from "vue"
import AppFooter from "./app-footer"
import CardItem from "./card-item"
import ContentBloc from "./content-bloc"
import ImgSlider from "./img-slider"
import MainMenu from "./main-menu"

export default {
    ...AppFooter,
    ...CardItem,
    ...ContentBloc,
    ...ImgSlider,
    ...MainMenu
} as Record<string, Component>